import { RouteInfo } from './sidebar.metadata';

export function getAlldata() {
    const dsROUTES: RouteInfo[] = []
    if (sessionStorage.getItem('claimFinancing') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'Claim Financing', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [   
                    {
                        path: '/Admin/Invoice/Dashboard/dashboardMaster', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Invoice/Invoice-Status/Claim-invoice', title: 'Claim Invoices', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('supplierFinancing') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'Supplier Financing', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Supplier/Dashboard/dashboardSupplier', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Supplier/Invoices/invoices', title: 'Invoices', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('purchaseFinancing') == 'true') {

        dsROUTES.push(
            {
                path: '', title: 'Purchase Financing', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,

                submenu: [
                    {
                        path: '/Admin/Pharmacy-Finance/Dashboard/dashboardPharmacy', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Pharmacy-Finance/Invoices/invoices', title: 'Invoices', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('merchantFinancing') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'Merchant Financing', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Merchant/Dashboard/dashboardMerchant', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Merchant/user-list', title: 'Master User List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Admin/Merchant/MerchantExcelData', title: 'Updated Status Data', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('patientFinancing') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'Patient Financing', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Patient/patientDashboard', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Invoice/Invoice-Status/Patient-invoice', title: 'Patient Invoices', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Admin/Invoice/Invoice-Status/OSV-Details', title: 'OSV Details', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }
    if (sessionStorage.getItem('tatkaal') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'TATKAAL', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Payment/Worldline-Dashboard', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Payment/Worldline-Payment', title: 'Initiate Payment', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Payment/Worldline-List', title: 'Transactions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    }
                ]
            },
        )
    }
    if(sessionStorage.getItem('isAbha') == 'true'){
        dsROUTES.push(
            {
                path: '', title: 'ABHA', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Abha/ABHA-Login/Abha-User-Login', title: 'ABHA Login', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Abha/ABHA-Aadhar/Aadhar-Verification', title: 'ABHA Creation', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Abha/ABHA-List/Abha-List', title: 'ABHA List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    // {
                    //     path: '/Admin/Abha/abha-form/abha-form', title: 'NHCX', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    // },
                ]
            },

        )
    }
    if (sessionStorage.getItem('accessControl') != "0" && sessionStorage.getItem('accessControl') != "1" && sessionStorage.getItem('accessControl') != "2") {
        dsROUTES.push(
            // {
            //     path: '', title: 'ABHA', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
            //     submenu: [
            //         {
            //             path: '/Admin/Abha/ABHA-Login/Abha-User-Login', title: 'ABHA Login', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            //         },
            //         {
            //             path: '/Admin/Abha/ABHA-Aadhar/Aadhar-Verification', title: 'ABHA Creation', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            //         },
            //         {
            //             path: '/Admin/Abha/ABHA-List/Abha-List', title: 'ABHA List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            //         },
            //     ]
            // },

            {
                // path: '', title: 'TATKAAL', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                path: '', title: 'TATKAAL', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        // path: '/Admin/Payment/Worldline-Dashboard', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                        path: '/Admin/Payment/Worldline-Dashboard', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Payment/Worldline-Payment', title: 'Initiate Payment', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Payment/Worldline-List', title: 'Transactions', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    }
                ]
            },
        )

        dsROUTES.push(
            {
                path: '', title: 'New Leads', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/contact/Leads-dashboard', title: 'Leads Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
    
                    {
                        path: '/Admin/contact/registered-list', title: 'List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('employeeManagement') == 'true') {
        dsROUTES.push(
            {
                path: '', title: 'Employee Management', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Invoice/Employee-Management/Dashboard', title: 'Dashboard', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Invoice/Employee-Management/employeeList', title: 'Employee List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },

                    {
                        path: '/Admin/Invoice/Employee-Management/employeeLoans', title: 'Employee Loans', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }

    if (sessionStorage.getItem('accessControl') != "0" && sessionStorage.getItem('accessControl') != "1" && sessionStorage.getItem('accessControl') != "2") {
        dsROUTES.push(
           {
                path: '', title: 'User Master', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/UserMaster/user-list', title: 'User', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
            {
                path: '', title: 'Organization', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Organization/organizations', title: 'Organizations', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
            {
                path: '', title: 'Association', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Association/Isurance/Insurance-list', title: 'Insurance Company', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Association/TPA/TPA-list', title: 'TPA List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Association/UWPartnar/Partnar-List', title: 'Associate Partner', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Association/Vendor_hospital_association/Vendor_hospital_List', title: 'Vendor Hospital', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Association/Aggregator_hospital_association/Aggregator_hospital_List', title: 'Associate Hospital', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Admin/Association/Vendor_distributor_association/Vendor_Distributor_List', title: 'Vendor Distributor1', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                ]
            },
        )
    }
    if (sessionStorage.getItem('isStorage') == 'true' ) {
        dsROUTES.push(
            {
                path: '', title: 'Storage', icon: '', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Admin/Storage/Upload', title: 'Upload', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    // {
                    //     path: '/Admin/Storage/List', title: 'List', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    // },
                ]
            },
        )
    }
    return dsROUTES
}
